import { ThunkAction } from "redux-thunk"
import { StoreState } from "../StoreState"
import { AnyAction } from "redux"
import { TModalResponseType } from "../../components/modal/common/modalTypes"
import { modalReducerActions } from "../reducers/modalReducer"
import { TAllModals } from "../../components/modal/common/SingleModal"

export interface IModalResponse {
    type: TModalResponseType
    data?: any
}

export const addModalThunk =
    (modal: TAllModals): ThunkAction<Promise<IModalResponse>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        const modalReponse = await new Promise<IModalResponse>((outerResolve) => {
            dispatch(
                modalReducerActions.addModal({ ...modal, callback: (respType, data) => outerResolve({ type: respType, data }) })
            )
        })
        return modalReponse
    }
